import { http } from ".."
import { updateInitialRankingPayload, updateUserAvatarProps, updateUserDoneAIWelcomeOnboardingTourProps, updateUserDoneOnboardingTourProps, updateUserPasswordProps, updateUserPersonalInformationProps, updateUserUserNameProps } from "./user-interface"

/**
 * Update user username
 * @param data Object
 * @returns axios http response
 */
export const upateUserUserName = (data: updateUserUserNameProps) => {
  return http.post('/users/update-username', data)
}


/**
 * Update user personal information
 * @param data Object
 * @returns axios http response
 */
export const upateUserPersonalInformation = (data: updateUserPersonalInformationProps) => {
  return http.post('/users/update-personal-information', data)
}


/**
 * Update user password
 * @param data Object
 * @returns axios http response
 */
export const upateUserPassword = (data: updateUserPasswordProps) => {
  return http.post('/users/update-password', data)
}


export const updateUserDoneOnboardingTour = (data: updateUserDoneOnboardingTourProps) => {
  return http.post('/users/update-onboarding-tour', data)
}

export const updateUserDoneAIWelcomeOnboardingTour = (data: updateUserDoneAIWelcomeOnboardingTourProps) => {
  return http.post('/users/update-ai-welcome-tour', data)
}

export const updateUserAvatar = (data: updateUserAvatarProps) => {
  return http.post('/users/update-user-avatar', data)
}

export const updateInitialRanking = (data: updateInitialRankingPayload) => {
  return http.post('/users/update-user-rank-initial', data)
}
